export const retainSamePathOnReload = (pathName: string) => {
  return !!['/p', '/e', '/g', '/v']?.find((el) => pathName?.includes(el));
};
